import type { FC } from 'react';
import { MatchMedia } from '@george-labs.com/design-system';

import type { Account } from '@shared/products-types';
import { useActiveProduct } from '@shared/products-core';
import type { ProductWithHelpers } from '@shared/products-core';

import { ProductImageUpload } from '../../ProductImageUpload';
import { ProductAvatar } from '../../../components/ProductAvatar';

export const PersonalizationAvatar: FC = () => {
    const product = useActiveProduct<ProductWithHelpers<Account>>();

    return (
        <MatchMedia max={MatchMedia.TIER.SM}>
            {({ isMatching }) => (
                <ProductImageUpload
                    dropdownToggle={
                        <ProductAvatar
                            product={product}
                            size={isMatching ? '64' : '96'}
                            hasColorPreview
                        />
                    }
                    imageChangeContext="accountDetails"
                    productType={product.type}
                    trigger="productIcon"
                />
            )}
        </MatchMedia>
    );
};
